class AuthError extends Error {
}
export default AuthError;
//# sourceMappingURL=AuthError.js.map